var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStore = function SvgStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#store_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#001B3A",
    d: "M18.75 7.408 17.575 2.5H3.425L2.25 7.408c-.2.85-.017 1.717.517 2.4.066.092.158.159.233.242v7.45h15v-7.45c.075-.075.167-.15.233-.233a2.8 2.8 0 0 0 .517-2.409M6.35 4.167l-.483 4.05c-.067.541-.5.95-1.009.95a.96.96 0 0 1-.775-.392 1.14 1.14 0 0 1-.208-.975l.867-3.633zm9.908 0 .875 3.633c.084.35.009.7-.208.975a.98.98 0 0 1-.783.392c-.509 0-.95-.409-1.009-.95l-.483-4.05zm-2.833 3.766a1.12 1.12 0 0 1-.275.892c-.192.217-.458.342-.8.342-.558 0-1.017-.492-1.017-1.092V4.167h1.634zm-3.758.142c0 .6-.459 1.092-1.075 1.092-.284 0-.542-.125-.742-.342a1.18 1.18 0 0 1-.275-.892l.458-3.766h1.634zm-5 7.758v-5.025c.066.009.125.025.191.025.725 0 1.384-.3 1.867-.791.5.5 1.167.791 1.925.791.725 0 1.375-.3 1.858-.775a2.73 2.73 0 0 0 1.909.775c.7 0 1.366-.291 1.866-.791a2.6 2.6 0 0 0 1.867.791c.067 0 .125-.016.192-.025v5.025z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "store_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h20v20H.5z"
  })))));
};
export default SvgStore;